import React from 'react'

//import Plyr from './plyr'

//import useProperties from '../hooks/use-properties'

const Video = () => {

  // const propertyData = useProperties()

  // const categories = {
  //   'all': 'All',
  //   'auction': 'Auction',
  //   'current': 'Current',
  //   'sold': 'Sold Properties',
  //   'vendors': 'Vendors',
  //   'company': 'Company',
  //   'team': 'Team'
  // }

  // const [current, setCurrent] = React.useState(0)
  // const [category, setCategory] = React.useState('all')
  // const [clicked, setClicked] = React.useState(false)

  // const { allWpProperty } = propertyData

  // allYoutubeVideo.nodes = allYoutubeVideo.nodes.map((v, i) => {
  //   let { title } = v
  //   let prop = allWpProperty.nodes.find((p, j) => {
  //     let { number, street_name, suburb } = p.propertyMeta
  //     return (
  //       title.toLowerCase().indexOf(street_name.toLowerCase()) !== -1 &&
  //       title.toLowerCase().indexOf(suburb.toLowerCase()) !== -1 &&
  //       title.toLowerCase().indexOf(number.toLowerCase()) !== -1
  //     )
  //   })
  //   v.property = prop
  //   return v
  // })

  // const _renderItem = (el, i) => {

  //   let property = null
  //   if (typeof el.property !== 'undefined') property = el.property.propertyMeta

  //   if (category === 'current' && property === null) return
  //   if (category === 'sold' && property !== null) return

  //   let onClick = () => {
  //     setCurrent(i)
  //     setClicked(true)
  //     window.scrollTo({ top: 0, behavior: 'smooth' })
  //   }

  //   let { title, description } = el

  //   let isAuction = description.indexOf('AUCTION')
  //   let isVendor = description.indexOf('VENDOR')
  //   let isCompany = description.indexOf('THE DEAL')
  //   let isTeam = description.indexOf('TEAM')

  //   if (category === 'auction' && isAuction === -1) return
  //   if (category === 'vendors' && isVendor === -1) return
  //   if (category === 'company' && isCompany === -1) return
  //   if (category === 'team' && isTeam === -1) return

  //   if (title.indexOf('-') !== -1) title = title.split('-').slice(1).join('-')

  //   let cars = property && property.cars + property.garages

  //   return (
  //     <div className='video-page__item' key={i} onClick={onClick}>
  //       <div className='video-page__item__left'>
  //         <picture>
  //           <img src={el.localThumbnail && el.localThumbnail.childImageSharp.original.src} alt={el.title} />
  //         </picture>
  //       </div>
  //       <div className='video-page__item__right'>
  //         <h6>{title}</h6>
  //         {property &&
  //           <ul>
  //             {property.beds && <li>{property.beds} Bed</li>}
  //             {property.baths && <li>{property.baths} Bath</li>}
  //             {cars > 0 && <li>{cars} Car</li>}
  //           </ul>
  //         }
  //       </div>
  //     </div>
  //   )
  // }

  return (
    <section className='video-page'>
      
    </section>
  )
}

export default Video